import { Box, Button, Container, Typography } from "@mui/material";
import { images } from "../../assets";
import en from "../../locales/en.json";
import es from "../../locales/es.json";
import it from "../../locales/it.json";
import { useLocation, useNavigate } from "react-router-dom";

const locales = { en, es, it };
const Varified = () => {
  const location = useLocation();
  const language = location?.state?.language || "en";
  const url = location?.state?.url;
  const t = locales[language];
  const navigate = useNavigate();
  return (
    <>
      <Box display="flex" justifyContent="center" sx={{ pt: { xs: 4, md: 6 } }}>
        <img
          src={images.certageLogo}
          alt="Logo"
          style={{
            width: "min(70vw, 300px)",
            height: "auto",
            maxHeight: "140px",
          }}
        />
      </Box>

      <Container>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={2}
          sx={{ height: { xs: "40vh", md: "60vh" } }}
        >
          <img
            src={images.certageCheckmar}
            alt="Logo"
            style={{
              width: "min(70vw, 300px)",
              height: "auto",
              maxHeight: "140px",
            }}
          />
          <Typography textAlign="center" fontSize={20} color="primary.text">
            {t.verified.message}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"center"}
          sx={{ width: { xs: "100%", md: "70%" } }}
          mx="auto"
        >
          <Button
            fullWidth={false}
            onClick={() => {
              window.location.href = url;
            }}
            sx={{
              backgroundColor: "#1818de",
              px: { xs: 0, sm: 5 },
              py: 1.5,
              width: "70%",
              mx: "auto",
              borderRadius: "12px",
              mb: 2,
              fontSize: { xs: 16, sm: 24 },
              fontWeight: 600,
              color: "#fff",
              "&:hover": { backgroundColor: "#1515b0" },
            }}
          >
            {t.verified.button}
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default Varified;
